module.exports = __webpack_public_path__ + "static/media/IC_modeling_workbench.07e3e777.svg";